<div class="card ziro-search-result-card mb-2 overflow-hidden">
  <div class="card-header d-flex align-items-center bg-white">
    <div class="flex-fill">
      <i [ngClass]="icon() + ' me-1'"></i>
      <span [innerHtml]="description() | escapeHtml" data-automation="search-result-description"></span>
    </div>
    <div class="d-flex">
      @if (isSyncInProgress()) {
        <span data-automation="search-result-warning-badge" class="badge bg-warning me-1 d-flex align-items-center">
          <i [ngClass]="ziroIcons.WARNING_TRIANGLE + ' me-1'"></i>
          <span [innerHTML]="'tkey;search.end_user_result.ldap_sync_in_progress' | escapeHtml"></span>
        </span>
      }

      <ng-template #tooltipContent><span [innerHTML]="edit?.tooltip | escapeHtml"></span></ng-template>
      @if (edit?.link) {
        <div
          class="me-1"
          [class.disabled]="edit?.isDisabled"
          [ngbTooltip]="tooltipContent"
          [disableTooltip]="!edit?.tooltip"
          data-automation="search-result-row-edit"
        >
          <a
            [routerLink]="edit.link"
            data-automation="search-result-row-edit-link"
            [class]="'btn btn-border ' + buttonSizes.XSMALL + ' ' + buttonStyles.OUTLINE_PRIMARY"
            [ngClass]="{ disableClick: edit.isDisabled, disabled: edit.isDisabled }"
          >
            <i [ngClass]="ziroIcons.EDIT"></i>
          </a>
        </div>
      }
      @if (pinReset?.link) {
        <div
          class="me-1"
          [class.disabled]="pinReset?.isDisabled"
          [ngbTooltip]="pinReset?.tooltip | translate"
          [disableTooltip]="!pinReset?.tooltip"
        >
          <a
            [routerLink]="pinReset.link"
            data-automation="search-result-row-pin-reset-link"
            [class]="'btn btn-border ' + buttonSizes.XSMALL + ' ' + buttonStyles.OUTLINE_PRIMARY"
            [ngClass]="{ disableClick: pinReset.isDisabled, disabled: pinReset.isDisabled }"
          >
            <i [ngClass]="ziroIcons.REFRESH"></i>
          </a>
        </div>
      }
      @if (delete?.isDeletable) {
        <ziro-button
          [dataAutomation]="'search-result-row-delete-button'"
          (clicked)="onDeleteClicked()"
          [buttonStyle]="buttonStyles.OUTLINE_DANGER"
          [buttonSize]="buttonSizes.XSMALL"
          [icon]="ziroIcons.DELETE_SMALL"
          [isDisabled]="delete?.isDisabled"
          [ngbTooltip]="delete.tooltip | translate"
        ></ziro-button>
      }
    </div>
  </div>
</div>
